import { HttpClient, HttpContext } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { IS_SKIP_HANDLE_ERROR } from '../api/api-http-context-token';


export class CustomTranslateLoader implements TranslateLoader {

  constructor(private http: HttpClient) {}

  public getTranslation(lang: string): Observable<any> {

    const baseUrl =
      `${environment.i18nPrefix}/assets/i18n/${lang}.json`;

    const theme = environment.themeDefault.toLowerCase();

    // load file gốc
    const baseRequest = this.http.get(baseUrl, {
      context: new HttpContext().set(IS_SKIP_HANDLE_ERROR, true)
    });

    // nếu không có theme
    if (!theme) {
      return baseRequest;
    }

    // load file theme
    const themeUrl = `${environment.i18nPrefix}/assets/i18n/${theme}/${lang}.json`;

    const themeRequest = this.http.get(themeUrl, {
      context: new HttpContext().set(IS_SKIP_HANDLE_ERROR, true)
    }).pipe(
      catchError(() => of({}))
    );

    return forkJoin([
      baseRequest,
      themeRequest
    ]).pipe(
      map(([baseTranslation, themeTranslation]) => {
        let translation = deepMerge(baseTranslation, themeTranslation);
        return translation;
      })
    );
  }
}

function deepMerge(target: any, source: any): any {

  const output = { ...target };

  if (isObject(target) && isObject(source)) {

    Object.keys(source).forEach(key => {

      if (isObject(source[key])) {

        if (!(key in target)) {
          output[key] = source[key];
        } else {
          output[key] = deepMerge(target[key], source[key]);
        }

      } else {
        output[key] = source[key];
      }

    });
  }

  return output;
}

function isObject(item: any) {
  return item && typeof item === 'object' && !Array.isArray(item);
}